import {Nullable} from "@data-force/app";

export class TabManager {
    private static instance: TabManager | null = null;

    private static newTab: Window;

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private constructor() {}

    /**
     * New tab getter
     * @return {Window}
     */
    private static getNewTab(): Window {
        return this.newTab;
    }

    /**
     * New tab setter
     * @param {Window} newTab
     * @private
     */
    private static setNewTab(newTab: Window): void {
        this.newTab = newTab;
    }

    /**
     * Method to get the single instance of the class
     * @return {TabManager}
     */
    public static getInstance(): TabManager {
        if (this.instance === null) {
            this.instance = new TabManager();
        }
        return this.instance;
    }

    /**
     * Opens a new tab with a "Please wait..." message displayed, waits for url to be loaded.
     * @param {Nullable<string>} url
     */
    public openTab(url: Nullable<string>): void {
        const newTabUrl: string = url || "loading.html";
        const newTab: Nullable<Window> = window.open(newTabUrl, "_blank");
        if (newTab) {
            TabManager.setNewTab(newTab);
        }
    }

    /**
     * Sets url for already opened new tabs, used in cases when we claim and open
     * @param {string} url
     */
    public setUrl(url: string): void {
        if (TabManager.getNewTab()) {
            TabManager.newTab.location.href = url;
        }
    }

    /**
     * Closes newly opened tab when we want to redirect user back to MDF
     */
    public closeTab() {
        TabManager.newTab.close();
    }

    /**
     * Checks if there is newly opened tab
     * @returns {boolean}
     */
    public hasOpenedTab(): boolean {
        return !!TabManager.getNewTab();
    }
}
